import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';



const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    padding: `${theme.spacing.unit * 3}px 0`,
    paddingRight: `${theme.spacing.unit * 1}px`,
  },
  textField: {
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  selectInput: {
    marginBottom: theme.spacing.unit * 2,
  },
  leftAligned: {
    textAlign: 'left',
    paddingLeft: theme.spacing.unit * 0.5,
  },
  rightAligned: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 0.5,
  },
});


class RepairDiscountForm extends React.Component {

  render = () => {
    const {classes, order, actions, showErrors, pricingMode} = this.props

    const {
      _errors,
      regularDiscountAmount,
      regularDiscountType,
      overtimeDiscountAmount,
      overtimeDiscountType,
    } = order

    const showOvertimeDiscount = ( order.pricingFormat !== 'Agreement Savings' && pricingMode === 'Legacy' )

    const discountType = (
      order.pricingFormat === 'Primary Additional'
      ? "Additional Repair Discount"
      : "Maintenance Agreement Discount"
    )

    const regularDiscountLabel = (
      showOvertimeDiscount
      ? "Regular Hours Discount"
      : "Agreement Discount"
    )

    const overtimeDiscountLabel = (
      "After Hours Discount"
    )

    return (
      <div>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={1}/>
          <Grid item xs={12} sm={10}>
            <Typography variant="body1">
              Please indicate the {discountType} you are offering customers.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}/>

          <Grid item xs={12} sm={1} md={2}/>
          <Grid item xs={12} sm={5} md={4}>
            <Grid container direction="column">
              <Grid item xs={12} style={{marginBottom:24}}>
                <TextField
                  fullWidth
                  label={regularDiscountLabel}
                  error={!!((regularDiscountAmount|| showErrors) && _errors.regularDiscountAmount)}
                  variant="outlined"
                  value={regularDiscountAmount}
                  onChange={e => actions.updateRegularDiscountAmount(order, e.target.value)}
                  InputProps={{
                    inputProps:{className: regularDiscountType === '%' ? classes.rightAligned : classes.leftAligned},
                    startAdornment: <InputAdornment>{ overtimeDiscountType === '$' ? '$' : ' ' /* To force label into lifted position */}</InputAdornment>,
                    endAdornment:   ( regularDiscountType === '%' ? <InputAdornment>%</InputAdornment> : null ),
                  }}
                >
                </TextField>
              </Grid>
            </Grid>
          </Grid>


          <Grid item xs={12} sm={5} md={4}>
            <Grid container direction="column">
              <Grid item xs={12}>
                {
                  showOvertimeDiscount
                  ? <TextField
                      fullWidth
                      label={overtimeDiscountLabel}
                      error={!!((overtimeDiscountAmount|| showErrors) && _errors.overtimeDiscountAmount)}
                      variant="outlined"
                      value={overtimeDiscountAmount}
                      onChange={e => actions.updateOvertimeDiscountAmount(order, e.target.value)}
                      InputProps={{
                        inputProps:{className: overtimeDiscountType === '%' ? classes.rightAligned : classes.leftAligned},
                        startAdornment: <InputAdornment>{ overtimeDiscountType === '$' ? '$' : ' ' /* To force label into lifted position */}</InputAdornment>,
                        endAdornment:   ( overtimeDiscountType === '%' ? <InputAdornment>%</InputAdornment> : null ),
                      }}
                    >
                    </TextField>
                  : null
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={1} md={2}/>

        </Grid>
      </div>
    )
  }
}

RepairDiscountForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  pricingMode: PropTypes.string,
};

export default withStyles(styles)(RepairDiscountForm);
